import React from 'react'
import PropTypes from 'prop-types'

import { useDispatch, shallowEqual, useSelector } from 'react-redux'
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import { EyeOff } from '@styled-icons/heroicons-outline/EyeOff'
import { Eye } from '@styled-icons/heroicons-outline/Eye'
import { selectConfiguredServicesFilters, setConfiguredServicesFilters } from 'slices/customer/customerDetailsSlice'

import { get } from 'utils/lodash'

const HeaderActionMenu = ({ anchorEl, onClose }) => {
  const dispatch = useDispatch()
  const csFilter = useSelector(selectConfiguredServicesFilters, shallowEqual)
  const withDeactivated = get(csFilter, 'withDeactivated')

  const handleToggleStatus = () => {
    dispatch(setConfiguredServicesFilters({ withDeactivated: !withDeactivated }))
    onClose()
  }

  return (
    <Menu
      slotProps={{ paper: { variant: 'outlined', sx: { minWidth: 250 } } }}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      disableScrollLock
      keepMounted
    >
      <MenuItem onClick={handleToggleStatus}>
        <ListItemIcon sx={{ mr: 1 }}>{withDeactivated ? <EyeOff width={24} height={24} /> : <Eye width={24} height={24} />}</ListItemIcon>
        <ListItemText>{withDeactivated ? 'Hide deactivated' : 'Show deactivated'}</ListItemText>
      </MenuItem>
    </Menu>
  )
}

HeaderActionMenu.propTypes = {
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
}

export default HeaderActionMenu
